'use strict';

import * as angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './containersShow';

export class ContainersShowController{
  constructor($scope, $http, $stateParams, $location, Container, $rootScope) {
    console.log('ContainersShowCtrl starting...');

    function getContainer() {
      Container.get({
        id: $stateParams.id,
        container_token: $stateParams.container_token,
        share_token: $stateParams.share_token,
      }).$promise
        .then((container) => {
          console.log("ContainersShowCtrl: /api/containers/ response:", container);
          $scope.container = container;
          $scope.hideAdvertisement = false;

          $rootScope.title = container.name;

          if ($stateParams.wm) {
            $scope.container.desktop.wm = $stateParams.wm;
          }
          if ($stateParams.splitpane === 'true') {
            // $scope.container.desktop.splitpane = !!($stateParams.splitpane);
            $scope.container.desktop.splitpane = true;
          }

          /*
          $scope.$watch('container.desktop.wm', (post, pre) => {
            $location.search('wm', container.desktop.wm);
          });
          */
          let windowModels = container.desktop.windowModels;
          if ($stateParams.windows) {
            let paramWindows;
            try {
              paramWindows = JSON.parse($stateParams.windows);
            } catch (e) {
              console.log("JSON.parse Error: ", e, ", String: ", $stateParams.windows);
              window.alert("JSON.parse Error: " + e + ", String: " + $stateParams.windows);
              return;
            }
            windowModels = paramWindows.map((paramWindow) => {
              let windowModel;
              if (paramWindow.application === 'browser') {
                paramWindow.model.url = paramWindow.model.url.replace(/\${CONTAINER_HOSTNAME}/g, container.containerHostname);
                paramWindow.model.url = paramWindow.model.url.replace(/\${CONTAINER_LOCALHOST}/g, 'localhost-' + container.containerHostname);
                if (paramWindow.model.watchPaths) {
                  paramWindow.model.watchPaths = paramWindow.model.watchPaths.map(
                    (watchPath) => watchPath.replace(/\${HOME}/g, '/home/ubuntu'));
                }
                windowModel = {
                  application: paramWindow.application,
                  model: paramWindow.model,
                  reconnect: paramWindow.reconnect,
                  /*model: {
                   url: paramWindow.url
                   },*/
                  ctrl: {},
                };
              } else if (paramWindow.application === 'editor') {
                paramWindow.model.filename = paramWindow.model.filename.replace(/\${HOME}/g, '/home/ubuntu');
                windowModel = {
                  application: paramWindow.application,
                  model: paramWindow.model,
                  /*model: {
                   filename: paramWindow.filename
                   },*/
                  ctrl: {},
                };
              } else if (paramWindow.application === 'terminal') {
                windowModel = {
                  application: 'tty',
                  model: {
                    command: paramWindow.model && paramWindow.model.command,
                  },
                  ctrl: {},
                };
              } else if (paramWindow.application === 'finder') {
                let dir = (paramWindow.model && paramWindow.model.dir) || '/home/ubuntu';
                windowModel = {
                  application: 'file-tree',
                  model: {
                    node: {text: dir, id: dir, children: true, icon: 'jstree-folder'},
                  },
                  ctrl: {},
                };
              } else {
                windowModel = {};
              }
              windowModel.title = paramWindow.model.title || windowModel.application;
              windowModel.closeable = paramWindow.model.closeable;
              windowModel.area = paramWindow.area;
              return windowModel;
            });
          }
          if (container.desktop.splitpane) {
            $scope.container.desktop.windowModels = [[]];
            windowModels.forEach((windowModel) => {
              let area = Math.floor(windowModel.area);
              $scope.container.desktop.windowModels[area] = $scope.container.desktop.windowModels[area] || [];
              $scope.container.desktop.windowModels[area].push(windowModel);
            });
            if ($scope.container.desktop.windowModels[0][0]) {
              $scope.container.activateWindowModel($scope.container.desktop.windowModels[0]);
            }
          } else {
            $scope.container.desktop.windowModels = windowModels;
            if ($scope.container.desktop.windowModels[0]) {
              $scope.container.activateWindowModel($scope.container.desktop.windowModels[0]);
            }
          }
          $scope.container.saveDesktop();
        })
        .catch((response) => {
          console.log("ContainersShowCtrl:Container.get:", response);
          window.swal({
            title: 'Container not found.',
            text: response.statusText,
            type: 'error',
          }, function() {
            $scope.$apply(() => {
              $location.path('/');
            });
          });
          return;
        });
    }

    if($stateParams.id !== 'remote'){
      getContainer();
    }else{
      /* XXX */
      const remoteHost = $stateParams.remote_host;
      $scope.container = new Container(Container.transformContainer({
        state: 'running',
        containerId: 'remote',
        containerHostname: remoteHost,
        containerAgentUrl: `http://${remoteHost}:3009`,
      }));
    }

    $scope.onremove = function(container){
      window.swal({
        title: 'お知らせ',
        text: 'コンテナは時間経過により削除されました。再度ご利用の際は、ブラウザをリロードしてください。',
        type: 'error',
      });
    };

    window.onbeforeunload = (e) => {
      let result;
      const container = $scope.container;
      let msg = container && container.ctrl.onbeforeunload && container.ctrl.onbeforeunload();
      if(msg){
        result = msg;
      }

      if(result){
        e.returnValue = result;
        return result;
      }
    };
    $scope.$on('$destroy', () => {
      window.onbeforeunload = () => {};
    });

  }
}

export default angular.module('paizacloudApp.containersShow', [uiRouter])
  .config(routing)
  .component('containersShow', {
    templateUrl: 'app/containersShow/containersShow.html',
    controller: ContainersShowController,
    // authenticate: false,
  })
  .name;
